import * as React from "react";
import { cn } from "../../../lib/utils";

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    // Function to handle input and restrict non-numeric characters only for tel type
    const handleInput = (e: React.FormEvent<HTMLInputElement>) => {
      if (type === "tel") {
        const inputValue = e.currentTarget.value;
        const sanitizedValue = inputValue.replace(/[^0-9()+\s]/g, "");
        e.currentTarget.value = sanitizedValue;
      }
    };

    return (
        <input
          type={type}
          className={cn(
          "appearance-none flex h-11 w-full rounded-2xl border border-slate-200 bg-slate-50/80 px-4 py-3 text-sm text-slate-900 shadow-sm transition-all duration-200 placeholder:text-slate-400 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-rose-100 focus-visible:border-rose-300 focus-visible:bg-white disabled:cursor-not-allowed disabled:opacity-50",
          className,
        )}
        ref={ref}
        {...props}
        onInput={handleInput}
      />
    );
  },
);
Input.displayName = "Input";

export { Input };
